
import { defineComponent, ref, PropType } from 'vue'
import {
    Package,
    usePackageModule
} from '@/modules/packages'
import PackagesFormFieldName from '@/components/packages/form-field/name.vue'
import PackagesFormFieldCode from '@/components/packages/form-field/code.vue'
import PackagesFormFieldDescription from '@/components/packages/form-field/description.vue'
import PackagesFormFieldStatus from '@/components/packages/form-field/status.vue'
import PackagesFormFieldCreatedAt from '@/components/packages/form-field/created-at.vue'
import PackagesFormFieldUpdatedAt from '@/components/packages/form-field/updated-at.vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { useRouter, useRoute } from 'vue-router'
import { useFormModule } from '@/modules/_shared/forms'
import { PackagesRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'packages-edit-package-form',
    components: {
        PackagesFormFieldName,
        PackagesFormFieldCode,
        PackagesFormFieldDescription,
        PackagesFormFieldStatus,
        PackagesFormFieldCreatedAt,
        PackagesFormFieldUpdatedAt
    },
    props: {
        package: {
            type: Object as PropType<Package>,
            required: true
        },
        packageCode: {
            type: String,
            required: true
        }
    },
    emits: ['formSent', 'deletePackage'],
    setup (props, { emit }) {
        const { updatePackage } = usePackageModule()
        const { submitForm, createOnSuccess } = useFormModule()

        const form = ref<QForm>()
        const router = useRouter()
        const route = useRoute()

        const isCodeReadonly = ref(true)
        const packageModel = ref(props.package)

        const sendRequest = async () => updatePackage(props.package.id, packageModel.value as Package)
        const moveToList = () => router.push({ name: PackagesRouteNames.LIST, query: { page: route.query.page } })

        const onDeletePackage = () => emit('deletePackage')

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Package has been successfully updated')
        ).then(moveToList)

        return {
            packageModel,
            onSubmit,
            form,
            PackagesRouteNames,
            isCodeReadonly,
            onDeletePackage,
            route
        }
    }
})
